import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContactMessageModel } from 'src/app/shared/services/evergent/onboarding/model/get-profiles/get-contact-response.model';

@Component({
  selector: 'app-profile-card',
  templateUrl: './profile-card.component.html',
  styleUrls: ['./profile-card.component.scss'],
})
export class ProfileCardComponent {
  @Input() index: number = 0;
  @Input() isLast: boolean = false;
  @Input() label: string = '';
  @Input() selected: boolean = false;
  @Input() profile: ContactMessageModel;

  @Output() profileClick = new EventEmitter<ContactMessageModel>();

  onProfileClick() {
    if (!this.selected) {
      this.profileClick.emit(this.profile);
    }
  }
}
